module.exports = __webpack_public_path__ + "media/packs/common/assets/images/mimamori/mimamori_frame-07ec29a183335cf093270683fd6ef02c.png";